import { Box, Typography, Container, Grid } from "@mui/material";
import { useState } from "react";

const ProcessCard = ({ defaultImage, hoverImage }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        cursor: "pointer",
        overflow: "hidden",
      }}
    >
      {/* Default Image */}
      <Box
        component="img"
        src={defaultImage}
        alt="Process Step"
        sx={{
          width: "100%",
          width: { xs: "376px", md: "100%" },
          height: "auto",
          display: "block",
          borderRadius: "16px",
          position: "relative",
          transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
          transform: isHovered ? "translateY(-100%)" : "translateY(0)",
          opacity: isHovered ? 0 : 1,
        }}
      />

      {/* Hover Image */}
      <Box
        component="img"
        src={hoverImage}
        alt="Process Step Hover"
        sx={{
          width: "100%",
          height: "auto",
          display: "block",
          borderRadius: "16px",
          position: "absolute",
          top: 0,
          left: 0,
          transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
          transform: isHovered ? "translateY(0)" : "translateY(100%)",
          opacity: isHovered ? 1 : 0,
        }}
      />
    </Box>
  );
};

const Process = () => {
  const processSteps = [
    {
      defaultImage: "/assets/processone.svg",
      hoverImage: "/assets/processhoverone.svg",
    },
    {
      defaultImage: "/assets/processtwo.svg",
      hoverImage: "/assets/processhovertwo.svg",
    },
    {
      defaultImage: "/assets/processthree.svg",
      hoverImage: "/assets/processhoverthree.svg",
    },
    {
      defaultImage: "/assets/processfour.svg",
      hoverImage: "/assets/processfourhover.svg",
    },
    {
      defaultImage: "/assets/processfive.svg",
      hoverImage: "/assets/processfivehover.svg",
    },
    {
      defaultImage: "/assets/processsix.svg",
      hoverImage: "/assets/processhoversix.svg",
    },
    {
      defaultImage: "/assets/processseven.svg",
      hoverImage: "/assets/processhoverseven.svg",
    },
    {
      defaultImage: "/assets/processeight.svg",
      hoverImage: "/assets/processhovereight.svg",
    },
  ];

  return (
    <Box id="process" sx={{ py: 8 }}>
      <Container maxWidth="xl">
        {/* Heading */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            className="font-weight-700"
            sx={{
              fontSize: { xs: "38px", md: "48px" },
              fontWeight: 700,
              color: "#333333",
              mb: 2,
              textAlign: "center",
              lineHeight: { xs: "1.2", md: "normal" },
            }}
          >
            Here's{" "}
            <Box
              component="span"
              sx={{
                fontFamily: '"Test Domaine Display", serif',
                fontSize: { xs: "38px", md: "48px" },
                fontWeight: 500,
                fontStyle: "italic",
                color: "#333333",
                lineHeight: { xs: "56px", md: "50px" },
                letterSpacing: "0%",
              }}
            >
              how
            </Box>
            <Box component="br" sx={{ display: { xs: "block", md: "none" } }} />
            <Box
              component="span"
              sx={{
                fontSize: { xs: "38px", md: "48px" },
                fontWeight: 700,
                color: "#333333",
                mb: 2,
              }}
            >
              {" "}
              the process goes
            </Box>{" "}
          </Typography>
          <Box
            component="img"
            src="/assets/divider.svg"
            alt=""
            sx={{
              width: { xs: "100%", md: "536px" },
              maxWidth: "536px",
              height: "auto",
              mx: "auto",
              display: "block",
            }}
          />
        </Box>

        {/* Process Cards Grid */}
        <Grid
          container
          spacing={3}
          sx={{
            justifyContent: "center",
          }}
        >
          {processSteps.map((step, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              lg={3}
              key={index}
              sx={{
                maxWidth: { xs: "500px", sm: "none" },
              }}
            >
              <ProcessCard
                defaultImage={step.defaultImage}
                hoverImage={step.hoverImage}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Process;
